import { render, staticRenderFns } from "./StatisticPanel.vue?vue&type=template&id=aa5bec06&lang=pug&"
import script from "./StatisticPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticPanel.vue?vue&type=style&index=0&scope=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports